"use client";

import { useState } from "react";

import { strings } from "@perceptron/constants";
import { SelectButton, SelectButtonLabel, SelectButtonValue } from "@perceptron/ui/components/selectButton";

import { MODE_META } from "@demo/constants/mode";
import { useMode } from "@demo/hooks/useMode";

import ModeSelector from "./ModeSelector";

/**
 * Header trigger that opens the mode selector. Shows the current mode's icon +
 * label in a pill and owns the selector's open state.
 */
const ModeSwitcher = () => {
  const [open, setOpen] = useState(false);
  const [mode] = useMode();
  const meta = MODE_META[mode];

  return (
    <>
      <SelectButton onClick={() => setOpen(true)}>
        <SelectButtonLabel>{strings.modeSwitcher.triggerLabel}</SelectButtonLabel>
        <SelectButtonValue icon={meta.icon}>{meta.label}</SelectButtonValue>
      </SelectButton>
      <ModeSelector open={open} onOpenChange={setOpen} />
    </>
  );
};

export default ModeSwitcher;
